import { useAuthenticatedAPI } from "@/api";
import { SKIP_LICENSING_CHECK } from "@/constants";
import { GetFeatureFlagClientAppEnum, GetFeatureFlagFeatureFlagEnum } from "@norma-bi/bi-api";
import { useQuery } from "@tanstack/react-query";

export function useGetLicensingFeatureFlag() {
  const api = useAuthenticatedAPI();
  return useQuery({
    queryKey: ["getLicensingFeatureFlag"],
    queryFn: () => {
      if (SKIP_LICENSING_CHECK === "check-with-server") {
        return api.getFeatureFlag({
          feature_flag: GetFeatureFlagFeatureFlagEnum.licensing,
          client_app: GetFeatureFlagClientAppEnum.web_app,
        });
      }
      return { enabled: !SKIP_LICENSING_CHECK };
    },
    staleTime: 1000 * 60 * 60 * 12, // 12 hours
  });
}
